<unauthorized [ngClass]="{ 'block' : unauthorized == true, 'hidden' : unauthorized == false || unauthorized == undefined }"></unauthorized>
<div class="justify-center items-center md:items-start flex flex-col md:flex-row gap-4" [ngClass]="{ 'hidden' : unauthorized == true }">
    <form [formGroup]="searchForm" (submit)="onSearchClicked()" class="flex flex-col justify-start text-md w-[24rem] sm:w-[360px]">
        <div class="flex flex-row sm:flex-col gap-2 bg-slate-100 rounded shadow p-2 text-xs sm:text-sm justify-center">
            <div class="flex flex-col gap-2 grow">
                <div class="flex flex-row gap-2 items-center">
                    <div class="font-bold w-[6ch] text-right">Name:</div>
                    <input formControlName="name" type="text" class="bg-slate-50 rounded p-1 shadow-sm grow" placeholder="">
                    <input formControlName="exactName" type="checkbox" id="exactNameCheckbox">
                    <label for="exactNameCheckbox">Exact</label>
                </div>
                <div class="flex flex-row gap-2 items-center">
                    <div class="font-bold w-[6ch] text-right">Date:</div>
                    <input formControlName="startDate" type="date" class="bg-slate-50 rounded p-1 shadow-sm" value="">
                    <div class="grow text-center">-</div>
                    <input formControlName="endDate" type="date" class="bg-slate-50 rounded p-1 shadow-sm" value="">
                </div>
            </div>
            <button (click)="onSearchClicked()" class="w-[12ch] sm:w-full flex flex-row gap-1 border border-transparent stroke-slate-900 hover:stroke-ponder-linkhover hover:text-ponder-linkhover hover:border-ponder-linkhover bg-slate-50 rounded p-1 shadow-sm items-center justify-center">
                <svg class="w-6 h-6 fill-none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" stroke-width="1.5">
                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="searchSvgIcon" />
                </svg>
                <div class="hidden sm:block">
                    Search
                </div>
            </button>
        </div>
    </form>
    <div class="w-[24rem] sm:w-[48rem] flex flex-col bg-slate-50 rounded-md shadow">
        <div class="flex flex-row items-center bg-ponder-light text-slate-50 rounded-t-md shadow p-2">
            <div class="grow font-bold">
                Collection History
            </div>
            <button (click)="onClickUndoSelected()" class="text-sm rounded-sm shadow-sm text-slate-100 p-1 pl-3 pr-3 bg-ponder-link hover:bg-ponder-linkhover disabled:bg-ponder-xlight disabled:text-slate-400" [disabled]="!areActionsSelected()">
                Undo Selected
            </button>
        </div>
        @if (isLoading || !loadingSuccess) {
            <loading class="p-16" [isLoading]="isLoading" [success]="loadingSuccess"></loading>
        } @else {
            @if (actions.length) {
                <div class="flex flex-row p-2 pt-1 pb-1 text-xs sm:text-sm shadow bg-slate-100 gap-2 items-center">
                    <div class="grow">
                        {{ start }} - {{ end }} of {{ total }}
                    </div>
                    <button (click)="onPrevClicked()" class="font-mono bg-slate-100 w-[8ch] sm:w-[10ch] rounded-sm hover:text-ponder-link border border-transparent hover:border-ponder-link hover:bg-slate-50 disabled:border-transparent disabled:text-slate-400 disabled:bg-transparent p-1" [disabled]="!hasNewer()">
                        &lt; Prev
                    </button>
                    <button (click)="onNextClicked()" class="font-mono bg-slate-100 w-[8ch] sm:w-[10ch] rounded-sm hover:text-ponder-link border border-transparent hover:border-ponder-link hover:bg-slate-50 disabled:border-transparent disabled:text-slate-400 disabled:bg-transparent p-1" [disabled]="!hasOlder()">
                        Next &gt;
                    </button>
                </div>
                <div class="flex flex-col bg-slate-50 shadow pb-2">
                    @for (action of actions ; track action.actionId) {
                        <user-collection-history-row [action]="action" [prevAction]="getPrevAction($index)"></user-collection-history-row>
                    }
                </div>
                <div class="flex flex-row p-2 pt-1 pb-1 text-xs sm:text-sm bg-slate-100 gap-2 items-center rounded-b">
                    <div class="grow">
                        {{ start }} - {{ end }} of {{ total }}
                    </div>
                    <button (click)="onPrevClicked()" class="font-mono bg-slate-100 w-[8ch] sm:w-[10ch] rounded-sm hover:text-ponder-link border border-transparent hover:border-ponder-link hover:bg-slate-50 disabled:border-transparent disabled:text-slate-400 disabled:bg-transparent p-1" [disabled]="!hasNewer()">
                        &lt; Prev
                    </button>
                    <button (click)="onNextClicked()" class="font-mono bg-slate-100 w-[8ch] sm:w-[10ch] rounded-sm hover:text-ponder-link border border-transparent hover:border-ponder-link hover:bg-slate-50 disabled:border-transparent disabled:text-slate-400 disabled:bg-transparent p-1" [disabled]="!hasOlder()">
                        Next &gt;
                    </button>
                </div>
            } @else {
                <div class="text-center p-12 text-slate-400">
                    No items found.
                </div>
            }
        }
    </div>
</div>